/*
 * @Description: 存塘概览-养成
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-19 14:07:32
 */
import http from "@/axios/index";
/**接口根路经标识 */

// --------------------------实时存塘量
export function initPageList(data) {
  const url = `/mdtPondStockOrg/searchMdtPondStockOrgList`
  return http.post(url, data)
}


// --------------------------月存塘成本
export function monthInitPageList(data){
  const url = `/midCostTotalOrg/getMonthlyStoragePondCost`
  return http.post(url, data)
}

// 养成--实时存塘量--获取所有公司（机构）
export function getAllJiGou(rootId){
  const url = `/desktopReport/queryCuntangOrgFish/${rootId}`
  return http.get(url)
}
// 养成--实时存塘量--获取所有造次
export function getAllPiCi(rootId){
  const url = `/desktopReport/queryCuntangPerioyFish/${rootId}`
  return http.get(url)
}
// 养成--实时存塘量--获取所有品类
export function getAllPinLei(rootId){
  const url = `/desktopReport/queryCuntangTypeFish/${rootId}`
  return http.get(url)
}
// 养成--实时存塘量--获取所有品种
export function getAllPinZhong(rootId){
  const url = `/desktopReport/queryCuntangBreedFish/${rootId}`
  return http.get(url)
}

// 养成--获取全部机构--月存塘成本
export function getAllJiGouMonth(rootId){
  const url = `/desktopReport/queryYuecunPondOrgFish/${rootId}`
  return http.get(url)
}

// 养成--获取全部造次--月存塘成本
export function getAllPiCiMonth(rootId){
  const url = `/desktopReport/queryYuecunPondPerioyFish/${rootId}`
  return http.get(url)
}
// 养成--获取全部品类--月存塘成本
export function getAllPinLeiMonth(rootId){
  const url = `/desktopReport/queryYuecunPondTypeFish/${rootId}`
  return http.get(url)
}
// 养成--获取全部品种--月存塘成本
export function getAllPinZhongMonth(rootId){
  const url = `/desktopReport/queryYuecunPondBreedFish/${rootId}`
  return http.get(url)
}


